import { QueryClient } from "@tanstack/react-query";

// A customer portal is read-mostly and mobile-first: a customer opens it, checks a balance, and
// leaves. Longer staleness than the admin panel keeps a phone on a poor connection from refetching
// data that changes on a scale of days rather than minutes.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 2 * 60 * 1000,
      gcTime: 10 * 60 * 1000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});
